export const capitalizeFirstLetterOnly = (str) => {
    if (str === null || str === undefined) {
        return str;
    }
    return str.toString().charAt(0).toUpperCase() + str.toString().slice(1).toLowerCase();
}


export const capitalizeFirstLetter = (str) => {
    if (str === null || str === undefined) {
        return str;
    }
    return str.toString().charAt(0).toUpperCase() + str.toString().slice(1);
};


export const lowerCaseString = (str) => {
    if (str === null || str === undefined) {
        return str;
    }
    return str.toString().toLowerCase();
};


export const upperCaseString = (str) => {
    if (str === null || str === undefined) {
        return str;
    }
    return str.toString().toUpperCase();
};


export const containsOnlyLetters = (str) => {
    return /^[a-zA-Z\s]+$/.test(str.toString().trim());
};


export const containsOnlyNumbers = (str) => {
    return /^[0-9]+$/.test(str.toString().trim());
};


export const truncateString = (str, num) => {
    if (str.toString().length > num) {
        return str.toString().slice(0, num) + "...";
    } else {
        return str;
    }
};


export const replaceAlbanianChars = (str) => {
    return str.toString().toLowerCase().replace(/ë/g, "e").replace(/ç/g, "c");
};


export const containsPrefix = (phoneNumber, prefix) => {
    if (phoneNumber) {
        return phoneNumber.toString().includes(prefix.toString()); 
    }
    return false;
};


export const formatListNumber = (str) => {
    return str.toString() + ".";
};


export const formatNumber = (str) => {
    if (str === null || str === undefined) {
        return "";
    }
    return str.toLocaleString();
}